module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/village/levelIcon//6_Gold.png?v=385bdd84";